export default "__VITE_ASSET__x9Or7q81__"